import VOverflowBtn from './VOverflowBtn';
export { VOverflowBtn };
export default VOverflowBtn;
//# sourceMappingURL=index.js.map